<div class="container m-0">
    <app-online-hours [meterId]="meterId" (rangeWindowChange)="onRangeWindowChange($event)">
        <div class="row stats-row">
            <div class="stat-card">
                <div class="stat-main">
                    <span class="item-name">{{ "TOTAL_ONLINE" | translate }}</span>
                    <span class="title">{{ onlineDurationLabel }}</span>
                </div>
                <span class="status-badge">{{ "UPTIME" | translate }}:&nbsp;<span class="status-value online">{{ onlinePercentage | number: '1.0-0' }}%</span></span>
            </div>
            <div class="stat-card">
                <div class="stat-main">
                    <span class="item-name">{{ "TOTAL_OFFLINE" | translate }}</span>
                    <span class="title">{{ offlineDurationLabel }}</span>
                </div>
                <span class="status-badge">{{ "DOWNTIME" | translate }}:&nbsp;<span class="status-value offline">{{ offlinePercentage | number: '1.0-0' }}%</span></span>
            </div>
            <div class="stat-card">
                <div class="stat-main">
                    <span class="item-name">{{ "LAST_SEEN" | translate }}</span>
                    <span class="title">{{ lastSeen ? (lastSeen | date: 'dd MMM yyyy, h:mm a') : '/' }}</span>
                </div>
            </div>
        </div>
    </app-online-hours>
</div>
